import http from './http';

export default {
  // 登录
  login(data) {
    return http.post('/o1/Auth/login', data);
  },
  
  // 注册
  register(data) {
    return http.post('/o1/Auth/register', data);
  },
  
  // 登出
  logout() {
    return http.post('/o1/Auth/logout');
  },
  
  // 获取用户信息
  getUserInfo() {
    return http.get('/o1/Auth/userinfo');
  },
  
  // 修改密码
  changePassword(data) {
    return http.put('/o1/Auth/password', data);
  },
  
  // 更新用户信息  
  updateUserInfo(data) {
    return http.post('/o1/Auth/profile', data);
  },
  
  // 获取用户列表
  getUserList(params) {
    return http.get('/organizer/users', params);
  },
  
  // 创建用户
  createUser(data) {
    return http.post('/organizer/users', data);
  },
  
  // 更新用户
  updateUser(userId, data) {
    return http.put(`/organizer/users/${userId}`, data);
  },
  
  // 删除用户
  deleteUser(userId) {
    return http.delete(`/organizer/users/${userId}`);
  },
  
  // 批量导入用户
  importUsers(file) {
    const formData = new FormData();
    formData.append('file', file);
    return http.upload('/organizer/users/import', formData);
  },
  
  // 重置用户密码
  resetUserPassword(userId, data) {
    return http.put(`/organizer/users/${userId}/password`, data);
  },
  
  // 启用/禁用用户
  toggleUserStatus(userId, status) {
    return http.put(`/organizer/users/${userId}/status`, { status });
  }
};
